import { ReduxState } from "Store/rootReducer";
import { useSelector } from "react-redux";
import { ConsentState } from "./consentInterfaces";

export const useMarketingConsent = (): ConsentState => {
  const { marketingConsent } = useSelector((state: ReduxState) => state);
  return marketingConsent;
};

export const useAkaConsent = (): ConsentState => {
  const { akaConsent } = useSelector((state: ReduxState) => state);
  return akaConsent;
};
